import { useIntl } from "react-intl";
import { useMemo } from "react";
import { groupBy } from "lodash";

import { FavouriteItem } from "../../../types";
import { Hierarchy } from "../../../../common";

import { FAVOURITE_ITEMS_GROUPS } from "./FavouriteItemsTree.constants";
import { IHierarchyItem } from "./FavouriteItemsTree.types";

export function useFavouriteItemsHierarchy(favouriteItems: FavouriteItem[]): Hierarchy<string, IHierarchyItem>[] {
  const { formatMessage } = useIntl();

  const hierarchies = useMemo(() => {
    const groupedFavouriteItems = groupBy(favouriteItems, (item) => item.type);

    return FAVOURITE_ITEMS_GROUPS.map<IHierarchyItem>((group) => ({ ...group, name: formatMessage(group.name) }))
      .map((group) => {
        const groupItems = groupedFavouriteItems[String(group.type)]?.map<IHierarchyItem>((fi) => ({ ...fi, id: String(fi.id) })).sort((a, b) => {
          const dateA = new Date(a.date).getTime();
          const dateB = new Date(b.date).getTime();
          return dateB - dateA;
        }) || [];
        const groupHierarchy = new Hierarchy(group.id, group.name, group);
        groupItems.forEach((favoriteItem) => {
          new Hierarchy(favoriteItem.id, favoriteItem.name, favoriteItem, groupHierarchy);
        });
        return groupHierarchy;
      })
      .filter((h) => h.children !== undefined && h.children?.length !== 0);
  }, [favouriteItems, formatMessage]);

  return hierarchies;
}
